import { theme } from '../../../theme/theme';

/**
 * Tint used until the entity's status is known (list not loaded yet, or entity has no
 * status). Matches the colour generateVehicleStatusColor gives an unknown status.
 */
export const DEFAULT_MARKER_COLOR = theme.colors.inactive;

/** Device map: colour the marker by device connectivity. */
export const deviceOnlineMarkerColor = (isOnline?: boolean | null): string => (
  isOnline ? theme.colors.green : theme.colors.red
);
